function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { sites } from '@immediate_media/site-config';
var getDefaultConfig = function getDefaultConfig(_ref) {
  var _sites$siteKey;
  var _ref$siteKey = _ref.siteKey,
    siteKey = _ref$siteKey === void 0 ? 'slate' : _ref$siteKey,
    namespaces = _ref.namespaces,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? 'en' : _ref$fallback;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!(siteKey in sites)) {
    console.error("".concat(siteKey, " is not a recognised site in the translation package. Default to slate"));
  }
  if (!Array.isArray(namespaces)) {
    throw new Error("Namespaces should be an array for example: ['".concat(namespaces, "']"));
  }
  var preferredSiteLanguage = 'en';
  var languages = []; // Set a default language

  if ((_sites$siteKey = sites[siteKey]) !== null && _sites$siteKey !== void 0 && _sites$siteKey.language) {
    var _sites$siteKey2;
    // Ensure only the main language is used: 'pl' not 'pl-PL'
    preferredSiteLanguage = (_sites$siteKey2 = sites[siteKey]) === null || _sites$siteKey2 === void 0 ? void 0 : _sites$siteKey2.language.split('-')[0];
  }
  languages.push(preferredSiteLanguage);
  if (preferredSiteLanguage !== fallback) {
    languages.push(fallback);
  }
  return _objectSpread(_objectSpread({}, options), {}, {
    lng: preferredSiteLanguage,
    ns: namespaces,
    // namespaces to load. DefaultNS is the first in the array
    fallbackNS: namespaces.slice(1),
    // Fallback to any other namespaces
    fallbackLng: fallback,
    supportedLngs: languages,
    load: 'languageOnly' // only 'en' not 'en-US'
  });
};

export default getDefaultConfig;